export interface GridPinnedRowsProps {
  position: 'top' | 'bottom';
}

export function GridPinnedRows(_: GridPinnedRowsProps) {
  return null;
}
